module.exports = __webpack_public_path__ + "static/media/syuukou-logo.eed2c9de.svg";